import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { AppBar as MuiAppBar, Hidden, Grid, Toolbar, Typography, Button } from '@material-ui/core';

import { APP_IMAGES } from 'app-constants';
import { getAppImage } from 'helpers';
import { Logout } from 'Links';

interface Props {
  logout?: boolean;
}

const BareAppBar: FC<Props> = ({ logout }) => {
  const { t } = useTranslation();

  return (
    <MuiAppBar position="fixed">
      <Toolbar>
        <Grid container alignItems="center">
          <Grid container item xs spacing={2}>
            <Grid item>
              <div style={{ width: 242, height: 30 }}>
                <img {...getAppImage(APP_IMAGES.Logo, 30)} />
              </div>
            </Grid>
            <Hidden smDown>
              <Grid item>
                <Typography variant="subtitle1">{t('components:description')}</Typography>
              </Grid>
            </Hidden>
          </Grid>
          {logout && (
            <Grid item>
              <Button component={Logout}>{t('common:logout')}</Button>
            </Grid>
          )}
        </Grid>
      </Toolbar>
    </MuiAppBar>
  );
};

BareAppBar.defaultProps = {
  logout: false,
};

export default BareAppBar;
